import { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router'
import SimpleBarCore from 'simplebar-core'
// @ts-ignore - simplebar-react ships without types
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'

import { useAuth } from '@/lib/auth'
import { Logo } from '@/nexus/components/Logo'

import { ISidebarMenuItem, SidebarMenuItem } from './SidebarMenuItem'
import { getActivatedItemParentKeys } from './helpers'

export const Sidebar = ({ menuItems }: { menuItems: ISidebarMenuItem[] }) => {
  const { pathname } = useLocation()
  const { user, logout } = useAuth()
  const scrollRef = useRef<SimpleBarCore | null>(null)
  const [activatedParents, setActivatedParents] = useState<Set<string>>(new Set())

  useEffect(() => {
    setActivatedParents(getActivatedItemParentKeys(menuItems, pathname))
  }, [menuItems, pathname])

  const onToggleActivated = (key: string) => {
    const next = new Set(activatedParents)
    if (next.has(key)) next.delete(key)
    else next.add(key)
    setActivatedParents(next)
  }

  const initials = (user?.email || 'A').slice(0, 2).toUpperCase()

  return (
    <>
      <input type="checkbox" id="layout-sidebar-toggle-trigger" className="hidden" aria-label="Toggle layout sidebar" />
      <input type="checkbox" id="layout-sidebar-hover-trigger" className="hidden" aria-label="Dense layout sidebar" />
      <div id="layout-sidebar-hover" className="bg-base-300 h-screen w-1"></div>

      <div id="layout-sidebar" className="sidebar-menu flex flex-col">
        <div className="flex h-16 min-h-16 items-center gap-3 ps-5 pe-4 border-b border-base-300">
          <Link to="/dashboard">
            <Logo />
          </Link>
        </div>

        <div className="relative min-h-0 grow">
          <SimpleBar ref={scrollRef} className="size-full">
            <div className="my-3 space-y-0.5 px-2.5">
              {menuItems.map((item, index) => (
                <SidebarMenuItem
                  {...item}
                  key={index}
                  activated={activatedParents}
                  onToggleActivated={onToggleActivated}
                />
              ))}
            </div>
          </SimpleBar>
        </div>

        <div className="border-t border-base-300 p-2.5">
          <div className="flex items-center gap-2.5 px-1">
            <span className="grid place-items-center h-8 w-8 rounded-full bg-primary/15 text-primary text-xs font-semibold shrink-0">
              {initials}
            </span>
            <div className="grow min-w-0">
              <p className="text-xs font-medium truncate" title={user?.email}>{user?.email || 'Signed in'}</p>
              <p className="text-base-content/50 text-[10px]">ASM International</p>
            </div>
            <button
              type="button"
              onClick={logout}
              title="Sign out"
              className="btn btn-ghost btn-xs btn-square text-base-content/50 shrink-0"
            >
              <span className="iconify lucide--log-out size-4" />
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
